"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useSalesEnablementContext_1 = require("../../../../src/gql/common/hooks/useSalesEnablementContext");
var useCheckoutContext_1 = require("../../../../src/gql/common/hooks/useCheckoutContext");
var DealStatus_1 = require("../../checkout4/enum/DealStatus");
var storageService_1 = require("../../../../../common/service/storageService");
var useCheckDealStatus = function () {
    var _a, _b;
    var VALID_STATUSES = [
        DealStatus_1.DealStatus.AUTHORIZED,
        DealStatus_1.DealStatus.CONTINUE_IN_DEALERSHIP_DETAILS_PROVIDED,
        DealStatus_1.DealStatus.RESERVE_ONLINE_DETAILS_PROVIDED,
        DealStatus_1.DealStatus.FAILED,
    ];
    var STATUS_OBJECT_KEY = 'export_details';
    var deal = useCheckoutContext_1.default().deal;
    var _c = useSalesEnablementContext_1.default(), isInSalesEnablement = _c.isInSalesEnablement, isDealExported = _c.isDealExported;
    var isValid = deal && VALID_STATUSES.includes(deal.status);
    var currentDealId = (_a = deal) === null || _a === void 0 ? void 0 : _a.uuid;
    var exportCounter = (_b = deal) === null || _b === void 0 ? void 0 : _b.exportCount;
    var isDealExportValid = (isValid && isInSalesEnablement) || isDealExported || exportCounter !== 0;
    var getStoredObject = react_1.useMemo(function () {
        return function () {
            var storedObjectString = storageService_1.default.get(STATUS_OBJECT_KEY);
            return storedObjectString ? JSON.parse(storedObjectString) : { exported: 'false', dealId: null };
        };
    }, [STATUS_OBJECT_KEY]);
    var _d = react_1.useState(getStoredObject().exported === 'true'), storedIsDealExportValid = _d[0], setIsDealExportValid = _d[1];
    var handleStorageValidation = function (currentDealId) {
        var storedObjectString = storageService_1.default.get(STATUS_OBJECT_KEY);
        if (storedObjectString) {
            var storedObject = JSON.parse(storedObjectString);
            if (storedObject.dealId !== currentDealId || !isInSalesEnablement) {
                storageService_1.default.remove(STATUS_OBJECT_KEY);
            }
        }
    };
    var handleStorageSave = function (currentDealId, isDealExportValid) {
        var storedExportDetails = getStoredObject();
        if (!(currentDealId === storedExportDetails.dealId && storedExportDetails.exported === 'true')) {
            var storageObject = {
                exported: String(!!isDealExportValid),
                dealId: currentDealId || null,
            };
            isInSalesEnablement && storageService_1.default.set(STATUS_OBJECT_KEY, JSON.stringify(storageObject));
        }
    };
    react_1.useEffect(function () {
        if (currentDealId && isValid !== null) {
            handleStorageValidation(currentDealId);
            handleStorageSave(currentDealId, isDealExportValid);
            setIsDealExportValid(getStoredObject().exported === 'true');
        }
    }, [currentDealId, isDealExportValid]);
    return { storedIsDealExportValid: storedIsDealExportValid };
};
exports.default = useCheckDealStatus;
